/**
 * @module Experience/Shop/Cart
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */

export const WINDOW_VARIABLE_KEYS = {
  innerHeight: 'innerHeight',
  pageYOffset: 'pageYOffset',
  nodeName: 'SECTION',
};
export const CART_LANDING_CONSTANTS = {
  AEM_PATH: 'cart',
  ACTIVATION: 'ACTIVATION',
  ESIM: 'ESIM',
  CART_REVIEW_CONTENT_PATH: 'cart/review',
  CART_REVIEW_PATH: '/cart/review',
  LINE_SETUP_PATH: '/cart/line-setup',
  ACCOUNT_SETUP_PATH: '/cart/account-setup',
  ORDER_REVIEW_PATH: '/cart/order-review',
  PRODUCT_SELECTOR_PATH: 'browse/productSelector',
  REMORSE: 'REMORSE',
  ASSESSMENT_TYPE_RETURN: 'return',
  ASSESSMENT_TYPE_EXCHANGE: 'exchange',
  CENTS: '00',
  RETURN_EXCHANGE_PRICE_MODULE_NAME: 'experience/shop/cart',
  MINUS: '-',
  INSTORE: 'instore',
  SHIPTO: 'shipTo',
  WARRANTY: 'WARRANTY',
  DEVICE: 'device',
  ACCESSORY: 'accessory',
  OFFER_TYPE_BASE: 'BASE',
  PURCHASED_EPIN: 'Purchase Epin',
  PIN: 'PIN',
  REDEEMED_EPIN: 'Redeemed Epin',
  ITEM_TYPE_VOUCHERREFILL: 'VOUCHERREFILL',
  ITEM_TYPE_PRODUCTOFFERING: 'PRODUCTOFFERING',
  CATEGORY_VOUCHER: 'VOUCHER',
  PRODUCT_TYPE_FINANCIALS: 'FINANCIAL',
  SUB_CATEGORY_EPINS: 'E-PIN',
  D2A: 'directToAcc',
  DEVICES: 'DEVICE',
  ACCESSORIES: 'ACCESSORY',
  RETURN_PAYMENT_URL: '/cart/return/payment',
  SHARED_CART_MODULE: 'SharedCartModule',
  DOLLAR_SIGN: '$',
  PAYMENT: 'Payment',
  VALID: 'VALID',
  REVIEW_ORDER_TITLE: 'Review your order',
  CONTINUE_BTN: 'continueBtn',
  CLEAR_CART_BTN: 'clearCartBtn',
  REMORSE_RETURN_TITLE: 'Review your remorse exchange',
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  SUSPENDED: 'SUSPENDED',
  CANCELLED: 'CANCELLED',
  ML_DISCOUNT_CART_BANNER: 'tppMlDiscountCartBanner',
  ONE: '1',
};
